<template>
  <div>
    <Carousel :perPage="1" :autoplay="true" :loop="true" :autoplayTimeout="6000" :paginationColor="'#003d57'" :paginationActiveColor="'#00ccd1'" :paginationSize="8">
      <Slide v-for="image in images" v-html="image" />
    </Carousel>
  </div>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel'

export default {
  name: "Gallerie",
  components: {Carousel, Slide},
  data() {
    return {
      images: [],
    }
  },
  beforeMount() {
    this.images = JSON.parse(document.getElementById(`vue-magasin__photos`).getAttribute('data-vue'))
  },
}
</script>

<style scoped lang="scss">

</style>
